import { tSharedAppState } from 'common/modules/ReactShared';
import { createSelector, Selector } from '@reduxjs/toolkit';
import { IState } from './types';

type tPaginationSelectorsConfig<GItem> = {
  selectStore: Selector<tSharedAppState, IState<GItem>>;
};

type tPaginationSelectors<GItem> = {
  selectStore: Selector<tSharedAppState, IState<GItem>>;
  selectItems: Selector<tSharedAppState, IState<GItem>['items']>;
  selectParams: Selector<tSharedAppState, IState<GItem>['params']>;
  selectPagination: Selector<tSharedAppState, IState<GItem>['pagination']>;
};

const createPaginationSelectors = <GItem>(
  config: tPaginationSelectorsConfig<GItem>
): tPaginationSelectors<GItem> => {
  const selectItems = createSelector([config.selectStore], (store) => store.items);

  const selectPagination = createSelector(
    [config.selectStore],
    (store) => store.pagination
  );

  const selectParams = createSelector([config.selectStore], (store) => store.params);

  return {
    selectStore: config.selectStore,
    selectItems,
    selectParams,
    selectPagination
  };
};

export { createPaginationSelectors };
export type { tPaginationSelectorsConfig, tPaginationSelectors };
